import { Component, Injectable, inject, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatError, MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { EcaFormColumnModule } from '@drc-eca/eca-components-lib';

@Component({
    selector: 'app-add-update-service-modal',
    standalone: true,
    templateUrl: './add-update-service-modal.component.html',
    styleUrls: ['./add-update-service-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ 
      MatDialogModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatError,
      MatIcon,
      MatButtonModule,
      EcaFormColumnModule,
      MatFormField,
      MatLabel,
      ReactiveFormsModule]
})
@Injectable({ providedIn: 'root' })
export class AddUpdateServiceModalComponent {
  dialogRef = inject<MatDialogRef<AddUpdateServiceModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  form: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl(null, Validators.required),
    description: new UntypedFormControl(null, Validators.required)
  });
  action: string = 'Add';

  constructor() {
      const data = this.data;
 
      if(data.selectedService){
        this.form.controls['name'].setValue(data.selectedService.name);
        this.form.controls['description'].setValue(data.selectedService.description);
        this.action = 'Update';
      }      
    }

}
